import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65ed804e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-left":"10px","margin-bottom":"10px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_the_statistic_ebook = _resolveComponent("the-statistic-ebook")!
  const _component_the_statistic_track = _resolveComponent("the-statistic-track")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"padding-top":"65px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_radio_group, {
              value: _ctx.currentKey,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentKey) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: "ebook" }, {
                  default: _withCtx(() => [
                    _createTextVNode("电子书")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "track" }, {
                  default: _withCtx(() => [
                    _createTextVNode("学习路径")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          (_ctx.currentKey == 'ebook')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_the_statistic_ebook)
              ]))
            : (_ctx.currentKey == 'track')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_the_statistic_track)
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}